import { ValueFormatterParams } from "@ag-grid-community/core";
import { DeleteOutlined } from "@ant-design/icons";
import { Checkbox, Modal, Tooltip } from "antd";
import { useContext } from "react";
import { MyContext } from "../../context/myContext";
import TeamMemberEditor from "./TeamMemberEditor";
import useApi from "../../hooks/useApi";
import teamMemberConfig from "../../api/TeamMembersConfig";


export const getTeamConfigDefs = ({ afterUpdate, getOrganization, getDynamicColumns }: any) => {

    const ActionButton = (props: ValueFormatterParams<any, any>) => {
        const deleteTeamMemberApi = useApi(teamMemberConfig.deleteTeamMember)

        const handleOk = async () => {
            const response = await deleteTeamMemberApi.request(props?.data?.product_name, props?.data?.team_name, `${props?.data?.team_member_email}@${getOrganization()}`)
            if (response?.data) {
                afterUpdate();
            }
        }

        const handleAction = () => {
            Modal.confirm({
                title: `Do you want to delete ${props?.data?.team_member_email}@${getOrganization()} from ${props?.data?.team_name}?`,
                content: "This action cannot be undone.",
                okText: "Yes",
                cancelText: "No",
                onOk: () => {
                    handleOk()
                },
            });
        };

        return (
            <> 
            <Tooltip title={'Delete'}>
                {props?.data?.id >= 0 ? <DeleteOutlined onClick={() => handleAction()} /> : null}
            </Tooltip>
            </>
        )
    }

    let columns = [
        {
            field: "team_member_email",
            headerName: "Team Member",
            headerTooltip: "Team Member",
            tooltipField: "team_member_email",
            cellStyle: { "cursor": "pointer" },
            cellClass: 'border-right',
            show: true,
            filter: 'agMultiColumnFilter',
            menuTabs: ['filterMenuTab', 'generalMenuTab'],
            editable: (params: any) => {
                return typeof params?.data?.id === 'number' ? false : true
            },
            valueFormatter: (props: ValueFormatterParams) => {
                return props?.data?.team_member_email ?
                    `${props?.data?.team_member_email}@${getOrganization()}`
                    : null;
            },
            cellEditor: TeamMemberEditor
        },
        {
            field: "first_name",
            headerName: "First Name",
            headerTooltip: "First Name",
            tooltipField: "manager",
            cellStyle: { "cursor": "pointer" },
            cellClass: 'border-right',
            show: true,
            filter: 'agMultiColumnFilter',
            menuTabs: ['filterMenuTab', 'generalMenuTab'],
            editable: true
        },
        {
            field: "last_name",
            headerName: "Last Name",
            headerTooltip: "Last Name",
            tooltipField: "last_name",
            cellStyle: { "cursor": "pointer" },
            cellClass: 'border-right',
            show: true,
            filter: 'agMultiColumnFilter',
            menuTabs: ['filterMenuTab', 'generalMenuTab'],
            editable: true
        },
        ...getDynamicColumns(),
        {
            field: "action",
            headerName: "",
            editable: false,
            sortable: false,
            filter: false,
            show: true,
            maxWidth: 50,
            minWidth: 50,
            resizable: false,
            cellStyle: () => { return { cursor: "pointer" } },
            cellRenderer: ActionButton,
        },
    ]

    return (
        columns
    )
}